import { useState } from 'react'

import GlobalIcon from '@icons/Global'

import IconButton from '@mui/material/IconButton'

import CBOsSupportMapDialog from '@pages/CBOs/CBOsSupportMapDialog'

export default function CBOSupportMap({ size }) {
  const [open, setOpen] = useState(false)

  return (
    <>
      <IconButton
        id="cbo-support-button"
        size={size}
        color="secondary"
        onClick={() => setOpen(true)}
        aria-label="CBO support map"
        data-testid="header-cbo-support-map"
      >
        <GlobalIcon style={{ fontSize: 18 }} />
      </IconButton>
      <CBOsSupportMapDialog open={open} onClose={() => setOpen(false)} />
    </>
  )
}
